import React from 'react';
import moment from 'moment';
import { DatePicker, Form, Icon, Modal } from 'antd';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { EditDocumentIcon } from '../../../resource/icons';

import actions from '../store/actions/edit-document.actions';
import { documentsActions } from '../store/actions/documents.actions';
import useChangeDeadlineDate from '../mutation/useChangeDeadlineDate';
import { toDateStr } from '../../../helpers/utcDate';

const EditResponceTimeModal = ({
  deadlineDate,
  visible,
  validateFields,
  getFieldDecorator,
  onCancel,
  prepareDataAndResetFields,
}) => {
  const dispatch = useDispatch();

  const { isLoadingDocDeadlineDate, changeDocDeadlineDate } =
    useChangeDeadlineDate();

  const onChanged = useCallback(() => {
    validateFields(async (err, values) => {
      if (err) return;
      const v = prepareDataAndResetFields(values);

      await changeDocDeadlineDate({
        docId: v.id,
        deadlineDate: toDateStr(values.changedResponceTime),
      });

      dispatch(documentsActions.fetchDocuments());
      dispatch(actions.closeModal());
    });
  }, [validateFields]);

  return (
    <Modal
      style={{ minWidth: 350 }}
      width={350}
      visible={visible}
      title={
        <span>
          <EditDocumentIcon
            style={{
              height: 40,
              verticalAlign: 'middle',
              marginRight: 10,
            }}
          />
          Срок ответа
        </span>
      }
      okText={isLoadingDocDeadlineDate ? <Icon type="loading" /> : 'Сохранить'}
      onCancel={onCancel}
      onOk={onChanged}
    >
      <Form layout="vertical">
        <Form.Item label="Срок">
          {getFieldDecorator('changedResponceTime', {
            initialValue: deadlineDate ? moment(deadlineDate) : moment(),
            rules: [
              {
                required: true,
                message: 'Пожалуйста, укажите срок ответа',
              },
            ],
          })(
            <DatePicker
              allowClear={false}
              format="DD.MM.YYYY"
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditResponceTimeModal;
